import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { DeliverySlotsResponse } from '~/api/ETA';

import DateItem from '../DateItem';

import styles from './DateSelector.module.scss';

interface DateSelectorProps {
  timeStamps: string[];
  selectedDate?: string;
  onDateChange: (date: string) => void;
  deliverySlots: DeliverySlotsResponse;
}

const DateSelector: FC<DateSelectorProps> = ({
  timeStamps,
  selectedDate,
  onDateChange,
  deliverySlots,
}) => {
  const dateCards = timeStamps.map((timeStamp) => (
    <DateItem
      key={timeStamp}
      timeStamp={timeStamp}
      onChange={onDateChange}
      isChecked={selectedDate === timeStamp}
      isDisabled={!deliverySlots[timeStamp]?.length}
    />
  ));

  return <div className={styles.dateSelector}>{dateCards}</div>;
};

export default observer(DateSelector);
